import { Link, Navigate, useParams } from "react-router-dom";
import { caseStudies } from "../content";

export function CaseStudyPage() {
  const { slug } = useParams();
  const study = caseStudies.find((item) => item.slug === slug);
  if (!study) return <Navigate to="/work" replace />;

  return (
    <main id="main-content" className={`interior-world case-world case-world--${study.tone}`}>
      <section className="case-cinema-hero">
        <div className="case-cinema-copy">
          <Link to="/work" className="case-back" data-hero-support>← All work</Link>
          <p className="route-kicker" data-hero-support>{study.kind}</p>
          <h1><span data-hero-line><span>{study.shortTitle}</span></span></h1>
          <p data-hero-support>{study.title}</p>
        </div>
        <div className="case-cinema-media" data-hero-visual>
          <img src={study.image} alt={study.imageAlt} />
        </div>
      </section>

      <section className="case-tag-rail" aria-label="Project capabilities">
        {study.tags.map((tag) => <span key={tag}>{tag}</span>)}
      </section>
      <p className="case-summary-rail" data-reveal>{study.summary}</p>

      <section className="case-tension">
        <div data-reveal>
          <span>The challenge</span>
          <p>{study.challenge}</p>
        </div>
        <div data-reveal>
          <span>The response</span>
          <p>{study.response}</p>
        </div>
      </section>

      <section className="case-delivery-world">
        <header data-reveal>
          <h2>What had to become real.</h2>
          <p>The visible experience and the operating system behind it were designed together.</p>
        </header>
        <div className="case-delivery-grid">
          {study.delivered.map((item) => <article key={item} data-reveal><p>{item}</p></article>)}
        </div>
      </section>

      <section className="case-evidence-world">
        <div data-reveal>
          <h2>Evidence, not theatre.</h2>
          <p>The project can be inspected through working artifacts rather than invented results.</p>
        </div>
        <div className="case-evidence-list">
          {study.proof.map((item) => <span key={item} data-reveal>{item}</span>)}
        </div>
      </section>

      <section className="case-next-world">
        <img src="/visuals/marky-work-exhibition.webp" alt="" aria-hidden="true" data-route-pan />
        <div>
          <p>Have a system with this many moving parts?</p>
          <Link className="world-button" to="/contact">Tell us what feels heavy <span aria-hidden="true">↗</span></Link>
        </div>
      </section>
    </main>
  );
}
